export type EmailTemplateLanguageType = "en" | "el";

export interface IEmailTemplateSubject {
  id: EmailTemplateSubjectEnum;
  labelEn: string;
  labelEl: string;
  alreadyInUse: boolean;
}

export enum EmailTemplateStatusEnum {
  Active,
  Inactive,
  Draft,
}

export interface ICreateOrUpdateEmailTemplate {
  subject: string;
  language: EmailTemplateLanguageType;
  status: EmailTemplateStatusEnum;
  content: string;
  // Email builder layout (JSON); null for HTML written by hand
  json: string | null;
}

export interface IEmailTemplateForTable {
  id: string;
  subject: EmailTemplateSubjectEnum;
  languages: string[];
  status: EmailTemplateStatusEnum;
  lastEdited: string;
}

export interface IEmailTemplateVersion {
  id: string;
  content: string;
  json: string | null;
  language: EmailTemplateLanguageType;
  emailTemplateId: string;
  emailTemplate: IEmailTemplate;
}

export interface IEmailTemplate {
  id: string;
  subject: EmailTemplateSubjectEnum;
  status: EmailTemplateStatusEnum;
  emailTemplateVersions: IEmailTemplateVersion[];
}

export enum EmailTemplateSubjectEnum {
  BookingCancellation = "BookingCancellation",
  BookingReminder = "BookingReminder",
  BookingConfirmation = "BookingConfirmation",
  // MembershipCancellationConfirmation = "MembershipCancellationConfirmation",
  MembershipConfirmation = "MembershipConfirmation",
  WelcomeEmailAndGuide = "WelcomeEmailAndGuide",
  VerificationEmail = "VerificationEmail",
  ForgotPassword = "ForgotPassword",
  ChangePasswordConfirmation = "ChangePasswordConfirmation",
}
